import { LabelText, TitleText } from '@policygenius/mortar';
import React from 'react';
import { useDispatch } from 'react-redux';

import Button from 'components/Button';
import { removeGlobalError } from 'containers/App/actions';

import styles from './global-error.module.scss';
import { IProps } from './types';

const GlobalError: React.FC<IProps> = ({ error }) => {
  const dispatch = useDispatch();
  const handleClick = () => dispatch(removeGlobalError());

  if (!error) {
    return null;
  }

  return (
    <div id="messages" className={styles.wrapper}>
      <div className={styles.alert}>
        <div className={styles['alert-box-content']}>
          <LabelText color="white" size="large">
            {error}
          </LabelText>
          <Button
            analyticsProperties={{
              text: error,
              source: 'global-error',
            }}
            className={styles.close}
            onClick={handleClick}
            fullWidth={false}
            variant="secondary-no-fill"
          >
            <TitleText as="span" color="white" size="large">
              ×
            </TitleText>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GlobalError;
